export const isArray = Array.isArray
